module.exports = __webpack_public_path__ + "img/betflix-support.872cdae1.jpg";